module.exports = __webpack_public_path__ + "img/186.895f0311.jpg";